import { render, staticRenderFns } from "./WireCheckManageDialog.vue?vue&type=template&id=3ff12e07&scoped=true"
import script from "./WireCheckManageDialog.vue?vue&type=script&lang=js"
export * from "./WireCheckManageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff12e07",
  null
  
)

export default component.exports